import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Home, History, BarChart3, Settings, LogOut, Moon, Sun, RefreshCw } from 'lucide-react';
import { useAuthStore } from '../stores/auth-store';
import { useThemeStore } from '../stores/theme-store';
import { ConfirmModal, Button } from '@dak/ui';

const navItems = [
  { to: '/', icon: Home, label: 'Today' },
  { to: '/history', icon: History, label: 'History' },
  { to: '/stats', icon: BarChart3, label: 'Stats' },
  { to: '/settings', icon: Settings, label: 'Settings' },
];

export function Layout({ children }: { children: React.ReactNode }) {
  const { signOut } = useAuthStore();
  const { dark, toggle } = useThemeStore();
  const [showSignOutModal, setShowSignOutModal] = useState(false);

  return (
    <div className="min-h-screen bg-surface">
      <nav className="bg-surface border-b border-border px-4 py-3">
        <div className="max-w-lg mx-auto flex items-center justify-between">
          <div className="flex items-center gap-1">
            {navItems.map(({ to, icon: Icon, label }) => (
              <NavLink
                key={to}
                to={to}
                end={to === '/'}
                className={({ isActive }) =>
                  `flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                    isActive
                      ? 'bg-surface-raised text-text'
                      : 'text-text-secondary hover:bg-surface-sunken'
                  }`
                }
              >
                <Icon size={18} />
                <span className="hidden sm:inline">{label}</span>
              </NavLink>
            ))}
          </div>
          <div className="flex items-center gap-1">
            <Button
              variant="ghost"
              size="icon"
              onClick={() => window.location.reload()}
              title="Reload"
            >
              <RefreshCw size={18} />
            </Button>
            <Button
              variant="ghost"
              size="icon"
              onClick={toggle}
              title={dark ? 'Light mode' : 'Dark mode'}
            >
              {dark ? <Sun size={18} /> : <Moon size={18} />}
            </Button>
            <Button
              variant="ghost"
              size="icon"
              onClick={() => setShowSignOutModal(true)}
              title="Sign Out"
            >
              <LogOut size={18} />
            </Button>
          </div>
        </div>
      </nav>
      <main className="max-w-lg mx-auto p-4">{children}</main>
      <ConfirmModal
        open={showSignOutModal}
        message="Are you sure you want to sign out?"
        confirmText="Sign Out"
        variant="primary"
        onConfirm={signOut}
        onClose={() => setShowSignOutModal(false)}
      />
    </div>
  );
}
